export default __webpack_public_path__ + "static/media/eximius.67bd8d42.png";